export function xyz(x, y, z) {
    return { x, y, z };
}
